import { HeadlineLevelContext } from "@/core/context/HeadlineLevelContext.tsx";
import { HeadingLevel } from "@public-ui/components";
import { KolHeading } from "@public-ui/react";
import { CSSProperties, FC, ReactNode, useContext } from "react";

interface IBaseHeadlineProps {
    /**
     * Text content
     */
    text: string;
    /**
     * Overrides level from current context
     */
    forceLevel?: HeadingLevel;
    /**
     * customization of the visual style
     */
    styling?: HeadingLevel;
    className?: string;
    /**
     * Inline styles forwarded to KolHeading (e.g. CSS custom properties).
     */
    style?: CSSProperties;
    /**
     * Optional react element for various action controls
     */
    action?: ReactNode;
}

const ALLOWED_STYLING_CLASSES = ["p", "h1", "h2", "h3", "h4", "h5", "h6"];

export const BaseHeadline: FC<IBaseHeadlineProps> = ({ text, forceLevel, styling, action, className, style }) => {
    const contextLevel = useContext(HeadlineLevelContext);
    const targetLevel = forceLevel !== undefined ? forceLevel : contextLevel;

    if (targetLevel < 0 || targetLevel > 6) {
        throw Error("Unknown level: " + contextLevel);
    }
    const cssClasses = className ?? "";
    const selectedStylingClasses = typeof styling === "undefined" ? cssClasses : ALLOWED_STYLING_CLASSES[styling] + " " + cssClasses;
    return (
        <div className="d-flex align-items-center" data-testid={`${text}-baseheadline-wrapper-testid`}>
            <KolHeading _label={text} className={selectedStylingClasses} _level={targetLevel as HeadingLevel} style={style} />
            {action && <span className="ms-3">{action}</span>}
        </div>
    );
};
